/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTodo = /* GraphQL */ `
  query GetTodo($id: ID!) {
    getTodo(id: $id) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTodos = /* GraphQL */ `
  query ListTodos(
    $filter: ModelTodoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTodos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        authorID
        author {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        title
        description
        start
        end
        fillColor
        textColor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAppOption = /* GraphQL */ `
  query GetAppOption($name: String!, $tag: String!) {
    getAppOption(name: $name, tag: $tag) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAppOptions = /* GraphQL */ `
  query ListAppOptions(
    $name: String
    $tag: ModelStringKeyConditionInput
    $filter: ModelAppOptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAppOptions(
      name: $name
      tag: $tag
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        name
        tag
        value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSequence = /* GraphQL */ `
  query GetSequence($name: String!, $tag: String!) {
    getSequence(name: $name, tag: $tag) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSequences = /* GraphQL */ `
  query ListSequences(
    $name: String
    $tag: ModelStringKeyConditionInput
    $filter: ModelSequenceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSequences(
      name: $name
      tag: $tag
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        name
        tag
        count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRole = /* GraphQL */ `
  query GetRole($id: ID!) {
    getRole(id: $id) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles(
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        functions {
          name
          enabled
          permission
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCorporate = /* GraphQL */ `
  query GetCorporate($id: ID!) {
    getCorporate(id: $id) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCorporates = /* GraphQL */ `
  query ListCorporates(
    $filter: ModelCorporateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCorporates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOffice = /* GraphQL */ `
  query GetOffice($id: ID!) {
    getOffice(id: $id) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOffices = /* GraphQL */ `
  query ListOffices(
    $filter: ModelOfficeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOffices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        corporateID
        corporate {
          id
          name
          furigana
          post
          pref
          address
          build
          tel
          fax
          logo
          sign
          bank {
            nextToken
            __typename
          }
          office {
            nextToken
            __typename
          }
          slipFormat
          startMonth
          invoice
          createdAt
          updatedAt
          __typename
        }
        name
        post
        pref
        address
        build
        tel
        fax
        sort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBank = /* GraphQL */ `
  query GetBank($id: ID!) {
    getBank(id: $id) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBanks = /* GraphQL */ `
  query ListBanks(
    $filter: ModelBankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBanks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        corporateID
        corporate {
          id
          name
          furigana
          post
          pref
          address
          build
          tel
          fax
          logo
          sign
          bank {
            nextToken
            __typename
          }
          office {
            nextToken
            __typename
          }
          slipFormat
          startMonth
          invoice
          createdAt
          updatedAt
          __typename
        }
        name
        store
        type
        no
        owner
        sort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        project {
          id
          code
          name
          corporateID
          customerID
          customer {
            id
            email
            passwd
            serial
            name
            office
            post
            pref
            address
            build
            tel
            fax
            url
            agencyID
            closing
            payment
            rate
            charge
            salesID
            color
            createdAt
            updatedAt
            __typename
          }
          deliveryDate
          documents {
            nextToken
            __typename
          }
          processes {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        name
        file
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDialy = /* GraphQL */ `
  query GetDialy($id: ID!) {
    getDialy(id: $id) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDialies = /* GraphQL */ `
  query ListDialies(
    $filter: ModelDialyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDialies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWork = /* GraphQL */ `
  query GetWork($id: ID!) {
    getWork(id: $id) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorks = /* GraphQL */ `
  query ListWorks(
    $filter: ModelWorkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dialyID
        dialy {
          id
          userID
          user {
            id
            first
            last
            email
            phone
            birthday
            department
            director
            joinDate
            unitPrice
            enabled
            role
            corporateIDs
            remarks
            employmentType
            paidRemain
            paidHoursUsed
            dailyWorktime
            createdAt
            updatedAt
            __typename
          }
          start
          works {
            nextToken
            __typename
          }
          probate
          unlock
          totalTime
          overTime
          midnightTime
          holidayTime
          holidayMignightTime
          createdAt
          updatedAt
          __typename
        }
        projectID
        project {
          id
          code
          name
          corporateID
          customerID
          customer {
            id
            email
            passwd
            serial
            name
            office
            post
            pref
            address
            build
            tel
            fax
            url
            agencyID
            closing
            payment
            rate
            charge
            salesID
            color
            createdAt
            updatedAt
            __typename
          }
          deliveryDate
          documents {
            nextToken
            __typename
          }
          processes {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        worktypeID
        workType {
          id
          code
          name
          createdAt
          updatedAt
          __typename
        }
        start
        end
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorkType = /* GraphQL */ `
  query GetWorkType($id: ID!) {
    getWorkType(id: $id) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorkTypes = /* GraphQL */ `
  query ListWorkTypes(
    $filter: ModelWorkTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorkTimeGroup = /* GraphQL */ `
  query GetWorkTimeGroup($id: ID!) {
    getWorkTimeGroup(id: $id) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorkTimeGroups = /* GraphQL */ `
  query ListWorkTimeGroups(
    $filter: ModelWorkTimeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkTimeGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        start
        end
        workTimes {
          items {
            id
            groupID
            start
            end
            name
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorkTime = /* GraphQL */ `
  query GetWorkTime($id: ID!) {
    getWorkTime(id: $id) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorkTimes = /* GraphQL */ `
  query ListWorkTimes(
    $filter: ModelWorkTimeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkTimes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        groupID
        start
        end
        name
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        start
        end
        name
        type
        color
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProcess = /* GraphQL */ `
  query GetProcess($id: ID!) {
    getProcess(id: $id) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProcesses = /* GraphQL */ `
  query ListProcesses(
    $filter: ModelProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        project {
          id
          code
          name
          corporateID
          customerID
          customer {
            id
            email
            passwd
            serial
            name
            office
            post
            pref
            address
            build
            tel
            fax
            url
            agencyID
            closing
            payment
            rate
            charge
            salesID
            color
            createdAt
            updatedAt
            __typename
          }
          deliveryDate
          documents {
            nextToken
            __typename
          }
          processes {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        name
        parentID
        dependentOn
        charge
        start
        end
        progress
        color
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getModel = /* GraphQL */ `
  query GetModel($id: ID!) {
    getModel(id: $id) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listModels = /* GraphQL */ `
  query ListModels(
    $filter: ModelModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubModel = /* GraphQL */ `
  query GetSubModel($id: ID!) {
    getSubModel(id: $id) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubModels = /* GraphQL */ `
  query ListSubModels(
    $filter: ModelSubModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        modelID
        model {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        name
        code
        value
        enabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFile = /* GraphQL */ `
  query GetFile($id: ID!) {
    getFile(id: $id) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFiles = /* GraphQL */ `
  query ListFiles(
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        name
        file
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderItem = /* GraphQL */ `
  query GetOrderItem($id: ID!) {
    getOrderItem(id: $id) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrderItems = /* GraphQL */ `
  query ListOrderItems(
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderID
        order {
          id
          corporateID
          customerID
          customer {
            id
            email
            passwd
            serial
            name
            office
            post
            pref
            address
            build
            tel
            fax
            url
            agencyID
            closing
            payment
            rate
            charge
            salesID
            color
            createdAt
            updatedAt
            __typename
          }
          projectID
          agencyID
          amount
          tax
          payment
          complete
          publish
          status
          transactionID
          transactionDate
          processID
          processPass
          createdAt
          estimateDate
          estimateLimit
          orderDate
          claimDate
          fixedDate
          paymentDate
          paymentTerms
          deliveryDate
          title
          remarks
          officeID
          chargeID
          orderItems {
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        modelID
        subModelID
        name
        quantity
        unit
        value
        remarks
        sort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStock = /* GraphQL */ `
  query GetStock($modelID: ID!, $createdAt: String!) {
    getStock(modelID: $modelID, createdAt: $createdAt) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStocks = /* GraphQL */ `
  query ListStocks(
    $modelID: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelStockFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStocks(
      modelID: $modelID
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        customerID
        modelID
        quantity
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentDoc = /* GraphQL */ `
  query GetPaymentDoc($id: ID!) {
    getPaymentDoc(id: $id) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPaymentDocs = /* GraphQL */ `
  query ListPaymentDocs(
    $filter: ModelPaymentDocFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentDocs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        corporateID
        pic
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentItem = /* GraphQL */ `
  query GetPaymentItem($id: ID!) {
    getPaymentItem(id: $id) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPaymentItems = /* GraphQL */ `
  query ListPaymentItems(
    $filter: ModelPaymentItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        paymentID
        payment {
          id
          no
          title
          kind
          corporateID
          customerID
          customer {
            id
            email
            passwd
            serial
            name
            office
            post
            pref
            address
            build
            tel
            fax
            url
            agencyID
            closing
            payment
            rate
            charge
            salesID
            color
            createdAt
            updatedAt
            __typename
          }
          orderDate
          claimDate
          fixedDate
          paymentDate
          amount
          tax
          payment
          commission
          complete
          pic
          remarks
          createdAt
          updatedAt
          __typename
        }
        modelID
        subModelID
        name
        quantity
        unit
        value
        remarks
        sort
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFacility = /* GraphQL */ `
  query GetFacility($id: ID!) {
    getFacility(id: $id) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFacilities = /* GraphQL */ `
  query ListFacilities(
    $filter: ModelFacilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFacilities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        name
        type
        enableWeek
        enableTime
        enableFewMonth
        minMinutes
        publish
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFacilityReserve = /* GraphQL */ `
  query GetFacilityReserve($id: ID!) {
    getFacilityReserve(id: $id) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFacilityReserves = /* GraphQL */ `
  query ListFacilityReserves(
    $filter: ModelFacilityReserveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFacilityReserves(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        facilityID
        customerID
        name
        start
        end
        color
        remarks
        charge
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAttendance = /* GraphQL */ `
  query GetAttendance($id: ID!) {
    getAttendance(id: $id) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAttendances = /* GraphQL */ `
  query ListAttendances(
    $filter: ModelAttendanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttendances(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        temperature
        mask
        alcohol
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($id: ID!) {
    getLog(id: $id) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        customerID
        type
        text
        createdAt
        ttl
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
